import { useNavigate } from 'react-router-dom';
import * as Toast from '~/lib/Toast';
import { handleFormSubmissionResponse } from '~/public/lib/handleFormSubmissionResponse.js';

export function hasPaymentStep(sections, answers, canPay) {
    if (!canPay) {
        return false;
    }

    /**
     * Figure out if we have a payment step:
     * - there's a form field with payment in the past or coming up?
     * - there's an appointment type with payment required
     * - AND they have a payment processor set up
     * maybe at first just change it based on the current answers, only if there's
     * an answer?
     */

    for (const answer of Object.values(answers)) {
        if (answer?.price > 0) {
            return true;
        }
    }

    return false;
}

export function useHandlePaymentReturnResponse() {
    const navigate = useNavigate();

    function handleResponse(result) {
        console.log('Payment return result = ', result);
        if (result['success']) {
            Toast.success(result['success']);
        }
        if (result['error']) {
            Toast.error(result['error']);
        }

        console.log('navigating to = ', result['redirectTo']);
        if (!handleFormSubmissionResponse(result)) {
            navigate(result['redirectTo']);
        }
    }

    return {
        handleResponse,
    };
}
